import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Checkbox,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { gradeActivityFromSpecificTrainingAction } from "@icarius-pages/myTraining/actions";
import Container from "../../../container";

const MarkActivityAssistanceDialog = (props) => {

  const {
    open,
    readOnly,
    trainingData,
    activityData,
    resolution,
    handleClose,
  } = props;

  const dispatch = useDispatch();
  const [assistance, setAssistance] = useState(resolution?.assistance || []);

  const handleSetAssistance = (assistanceIndex) => {
    setAssistance((prev) => {
      const newAssistance = [...prev];
      prev[assistanceIndex].hasAssistance = !prev[assistanceIndex].hasAssistance;
      return newAssistance;
    })
  }

  const submit = () => {
    dispatch(gradeActivityFromSpecificTrainingAction(trainingData.id, activityData.id, resolution.currentSession, { assistance }))
      .then((resp) => {
        if (resp.status === 200) {
          handleClose();
        }
      })
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {activityData.name} ({getLocalizedString("session")} {resolution.currentSession + 1} {getLocalizedString("of")} {resolution.sessions})
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent style={{ paddingTop: 0 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 15,
            }}
          >
            <div style={{ width: "100%" }}>
              <Container
                title={getLocalizedString("resolution")}
                style={{ width: "100%" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                  }}
                >
                  {
                    resolution.assistance.map((assistance, assistanceIndex) => {
                      return (
                        <Typography
                          key={assistanceIndex}
                          onClick={() => {
                            if (readOnly) return;
                            handleSetAssistance(assistanceIndex);
                          }}
                          style={{
                            fontSize: 14,
                            display: "flex",
                            alignItems: "center",
                            cursor: readOnly ? "" : "pointer"
                          }}
                        >
                          <Checkbox
                            checked={assistance.hasAssistance}
                            style={{ cursor: "pointer", color: "var(--mainText)" }}
                          />
                          {assistance.value}
                        </Typography>
                      )
                    })
                  }
                </div>
              </Container>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          {
            !readOnly &&
            <>
              <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
              <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
            </>
          }
          {
            readOnly &&
            <ButtonDialogAction onClick={handleClose} isAccept text={getLocalizedString("close")} />
          }
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default MarkActivityAssistanceDialog;